// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-page-create-team .modal2__container{
  width: 35%;
}

.modal-page-create-team.create-form .modal2__container{
  width: 60%;
}

.modal-page-create-team .modal2__header {
  border-bottom: none;
}

.modal-page-create-team-container{
  padding: var(--space);
}

.modal-page-create-team-information{
  display: grid;
  align-content: center;
  justify-content: center;
  justify-items: center;
}

.modal-page-create_newPage_data_logo_title {
  display: grid;
  justify-content: center;
  align-items: baseline;
}

.modal-page-create-team-information p{
  margin: 25px 32px 0px 32px;
  text-align: start;
  font-weight: var(--font-medium);
}


.modal-page-create_newPage_select .select-field-more-options {
  margin: var(--space-and-half) var(--space-x2);
}

.modal-page-create_newPage_select .select-field-more-options-input {
  border: 1px solid var(--new-gray-background-color);
  background-color: var(--white-color);
  padding: 30px 25px 30px 12px;
}

/* .modal-page-create_newPage_select .MuiSelect-nativeInput{
  opacity: 1; 
  border: none;
  margin-bottom: 12px;
  margin-left: 9px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.0025em;
  width: 80%;
  /* z-index: -10; 
} */


.modal-page-create-team-selected_option_title{
  margin-left:32px ;
}

.modal-page-create_newPage_buttons{
  display: grid;
  justify-content: end;
  margin-top: var(--space-x2);
}

.MuiFormGroup-root.modal-page-create_newPage__option-button{
  padding-bottom: var(--space-and-half);
}
.modal-page-create_newPage__option-button .MuiRadio-root{
  color: var(--new-gray-background-color);
}
.modal-page-create_newPage__option-button .MuiFormControlLabel-root{
  border-radius: 13px;
  border: 1px solid var(--new-gray-background-color);
  margin-left: 0;
  min-width: 145px;
  padding: 10px;
}
.modal-page-create_newPage__option-button .MuiFormControlLabel-root.selected{
  border: 1px solid var(--new-green-color);
  margin-left: 0;
  min-width: 145px;
}

.modal-page-create_newPage__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{
  margin: 0;
  padding: var(--space-half-quarter) var(--space);
  margin-right: var(--space);
  justify-content: space-between;
}
.MuiFormGroup-root.modal-page-create_newPage__option-button.inside {
  padding-bottom: 0;
  min-height: 48px;
}
.modal-page-create-radioButton .modal-page-create_newPage__option-button .MuiFormControlLabel-root{
  width: 100%;
  margin: var(--space-x2);
}

.modal-page-create_newPage__option-button .MuiFormControlLabel-label.Mui-disabled .baloa-username, 
.modal-page-create_newPage__option-button .MuiRadio-colorSecondary.Mui-disabled {
    color: var(--disabled-color);
}

.modal-page-create-radioButton span.baloa-username {
  color: var(--primary-very-dark-color);
  padding: var(--space) 0;
}

.modal-page-create-team-inf_img{
  margin: auto;
  width: 71px;
  height: 71px;
}

.modal-page-create_newPage_data_logo {
  margin-top: var( --space );
  display: flex;
  align-items: center;
  flex-direction: column;
}

.modal-page-create_newPage_data_logo .tournament-photo img {
  width: 142px;
  height: 142px;
  border-radius: 50%;
  justify-content: center;
  position: absolute;
}

.modal-page-create_newPage_data_logo .tournament-photo {
  width: 142px;
  height: 142px;
  border-radius: 50%;
  border: 1px dashed #7f9088;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: calc( var( --space-half-quarter ) + var( --space-eighth ) );
  cursor: pointer;
}

.modal-page-create_newPage_data_logo .tournament-photo .baloa-username{
  color: var( --new-green-color );
  font-weight: var( --font-medium );
  margin-left: var( --space-half );
}

.modal-page-create__check-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: var(--space-x2) var(--space-x2) var(--space-x3) var(--space-x2);
  padding: var(--space);
  border: 1px solid var(--new-gray-background-color);
  border-radius: var(--space-half);
}

.modal-page-create__check-box.active {
  border: 1px solid var(--new-green-color);
}

.modal-page-create__check-box__icon {
  display: flex;
  align-items: center;
}

.modal-page-create__check-box__icon span {
  font-size: var(--space-x2);
}

.modal-page-create__check-box__icon .baloa-hyperlink-2 {
  margin-left: var(--space-half-quarter);
  font-weight: var(--font-regular);
  color: var(--primary-dark-color);
}

.modal-page-create__check-box input[type="checkbox" i] {
  padding: 8px;
}

.select-field-more-options.page-team-create-modal__existing-page div#mui-component-select-selectedPage{
  display: flex;
  color: var( --primary-dark-color);
}

#menu-selectedPage .MuiPopover-paper{
  height: 20rem;
}

.modal-page-create_newPage_select_item{
  text-transform: none;
}

.modal-page-create_newPage_select_item .baloa-username{
  color: var(--primary-dark-color);
}

.modal-finish_createTeam-buttons{
  display: flex;
  justify-content: flex-end;
  margin-top: var(--space);
}

.page-information-form_left_submit{
  margin-right: var(--space)
}

.modal-finish_createTeam_codeTeam{
  display: flex;
  align-items: baseline;
  margin-bottom: var(--space);
}

.modal-finish_createTeam_code{
  background: var(--new-background-color);
  border-radius: 3px;
  padding: var(--space-half);
  width: 60%;
  text-align: center;
}

.modal-finish_createTeam{
  margin: var(--space-and-half);
}

.modal-finish_createTeam_code_click:hover{
  cursor: pointer;
}

.modal-finish_createTeam .modal-finish_creaTeam_code_text.baloa-table{
  font-size: 19px;
}

.modal-page-create-team-information_steps {
  border: 1px solid var(--new-gray-background-color);
  border-radius: 8px;
  background-color: #EDF2FC;
  margin: 25px 32px 26px 32px;
  padding: 16px;
}

.modal-page-create-team-steps-icon p {
  margin-left: 12px; 
}

.modal-page-create-team-steps-icon{
  display: flex;
  padding-bottom: 16px;
  align-items: center;
}

.modal-page-create-team-information_steps-info{
  padding-bottom: 11px;
}

.modal-page-create-team-steps-positions{
    color: var(--white-color);
    background: #5489E7;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.modal-page-create-team-information_icon{
  background: var(--primary-dark-color);
  color: var(--white-color);
  width: 60px;
  height: 60px;
  left: 268px;
  top: 0px;
  border-radius: 50%;
  padding: 15px;
}

.modal-page-create-team-information_icon span{
  font-size: 30px;
}

.modal-page-create_newPage_select div#mui-component-select-selectedPage{
 color:var(--body-background-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

  .modal-page-create-team .modal2__container {
    width: 100%;
    margin: 0;
    border-radius: 0;
    height: 100%;
    max-height: 100%;
  }

  .modal-page-create-team-container {
    height: 100%;
    padding: 0;
  }

  .modal-page-create-team-container .form,
  .modal-page-create-team .modal2__content {
    height: 100%;
    overflow: scroll;
  }

  .modal-page-create_newPage_buttons {
    display: block; 
    justify-content: unset; 
    margin-top: 0; 
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: var(--space);
  }

  .modal-page-create-team-container .button {
    width: 100%;
  }

  .modal-page-create-team.create-form .modal2__container {
    width: 100%;
  }

  .modal-page-create-team.create-form .form,
  .modal-page-create-team-container .form {
    margin-top: var(--space-x3);
  }

  .modal-page-create_newPage_data_logo .tournament-photo {
    width: 100px;
    height: 100px;    
  }

  .modal-page-create-information-form {
    flex-direction: column;
  }

  .modal-page-create_newPage_form_input .modal-page-create-information-form_input {
    width: 100%;
    margin-right: 0; 
    margin-left: 0; 
    padding: 0 var(--space);
  }

  .modal-page-create_newPage_form_input .modal-page-create-information-form_input_pagename {
    margin: 0;
    padding: 0 var(--space);
  }

  .modal-page-create_newPage_form_input .modal-page-create-information-form_input .input-field-label,
  .modal-page-create_newPage_form_input .modal-page-create-information-form_input_pagename .input-field-label {
    left: 12px;
  }  

  .modal-page-create_newPage_form_input {
    height: 100%;
  }

  .modal-page-create-information-form_buttons {
    margin-right: 0;
    position: absolute;
    bottom: 0;
    display: unset;
    width: 100%;
    padding: var(--space);
  }

  .select-field.new-team-form__form__input .MuiInputBase-root {
    width: 100%;
  }

  .form-group-new-team_form-buttons {
    display: unset;
    margin: 0;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 12px;
  }

  .page-team-create__team-code .modal2__container {
    width: 80%;
    border-radius: 0;
    height: 45%;
    border-radius: var(--space);
  } 

  .modal-finish_createTeam p{
    margin-bottom: 15px;
  }

  .modal-finish_createTeam_codeTeam{
    margin-bottom: var(--space-x2);
  }

  .modal-finish_createTeam-buttons{
    margin-top: 50px;
  }

  .modal-finish_creaTeam_code{
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0 var(--space);
  }

  .modal-finish_createTeam .modal-finish_creaTeam_code_text.baloa-table{
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/page-team-create-modal/PageTeamCreateModalComponent.styles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,+BAA+B;AACjC;;;AAGA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;GAeG;;;AAGH;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,+CAA+C;EAC/C,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mEAAmE;EACnE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uEAAuE;EACvE,qBAAqB;EACrB,kDAAkD;EAClD,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;CACC,kCAAkC;AACnC;;AAEA,yCAAyC,4BAA4B;;EAEnE;IACE,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".modal-page-create-team .modal2__container{\n  width: 35%;\n}\n\n.modal-page-create-team.create-form .modal2__container{\n  width: 60%;\n}\n\n.modal-page-create-team .modal2__header {\n  border-bottom: none;\n}\n\n.modal-page-create-team-container{\n  padding: var(--space);\n}\n\n.modal-page-create-team-information{\n  display: grid;\n  align-content: center;\n  justify-content: center;\n  justify-items: center;\n}\n\n.modal-page-create_newPage_data_logo_title {\n  display: grid;\n  justify-content: center;\n  align-items: baseline;\n}\n\n.modal-page-create-team-information p{\n  margin: 25px 32px 0px 32px;\n  text-align: start;\n  font-weight: var(--font-medium);\n}\n\n\n.modal-page-create_newPage_select .select-field-more-options {\n  margin: var(--space-and-half) var(--space-x2);\n}\n\n.modal-page-create_newPage_select .select-field-more-options-input {\n  border: 1px solid var(--new-gray-background-color);\n  background-color: var(--white-color);\n  padding: 30px 25px 30px 12px;\n}\n\n/* .modal-page-create_newPage_select .MuiSelect-nativeInput{\n  opacity: 1; \n  border: none;\n  margin-bottom: 12px;\n  margin-left: 9px;\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  letter-spacing: 0.0025em;\n  width: 80%;\n  /* z-index: -10; \n} */\n\n\n.modal-page-create-team-selected_option_title{\n  margin-left:32px ;\n}\n\n.modal-page-create_newPage_buttons{\n  display: grid;\n  justify-content: end;\n  margin-top: var(--space-x2);\n}\n\n.MuiFormGroup-root.modal-page-create_newPage__option-button{\n  padding-bottom: var(--space-and-half);\n}\n.modal-page-create_newPage__option-button .MuiRadio-root{\n  color: var(--new-gray-background-color);\n}\n.modal-page-create_newPage__option-button .MuiFormControlLabel-root{\n  border-radius: 13px;\n  border: 1px solid var(--new-gray-background-color);\n  margin-left: 0;\n  min-width: 145px;\n  padding: 10px;\n}\n.modal-page-create_newPage__option-button .MuiFormControlLabel-root.selected{\n  border: 1px solid var(--new-green-color);\n  margin-left: 0;\n  min-width: 145px;\n}\n\n.modal-page-create_newPage__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{\n  margin: 0;\n  padding: var(--space-half-quarter) var(--space);\n  margin-right: var(--space);\n  justify-content: space-between;\n}\n.MuiFormGroup-root.modal-page-create_newPage__option-button.inside {\n  padding-bottom: 0;\n  min-height: 48px;\n}\n.modal-page-create-radioButton .modal-page-create_newPage__option-button .MuiFormControlLabel-root{\n  width: 100%;\n  margin: var(--space-x2);\n}\n\n.modal-page-create_newPage__option-button .MuiFormControlLabel-label.Mui-disabled .baloa-username, \n.modal-page-create_newPage__option-button .MuiRadio-colorSecondary.Mui-disabled {\n    color: var(--disabled-color);\n}\n\n.modal-page-create-radioButton span.baloa-username {\n  color: var(--primary-very-dark-color);\n  padding: var(--space) 0;\n}\n\n.modal-page-create-team-inf_img{\n  margin: auto;\n  width: 71px;\n  height: 71px;\n}\n\n.modal-page-create_newPage_data_logo {\n  margin-top: var( --space );\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.modal-page-create_newPage_data_logo .tournament-photo img {\n  width: 142px;\n  height: 142px;\n  border-radius: 50%;\n  justify-content: center;\n  position: absolute;\n}\n\n.modal-page-create_newPage_data_logo .tournament-photo {\n  width: 142px;\n  height: 142px;\n  border-radius: 50%;\n  border: 1px dashed #7f9088;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: calc( var( --space-half-quarter ) + var( --space-eighth ) );\n  cursor: pointer;\n}\n\n.modal-page-create_newPage_data_logo .tournament-photo .baloa-username{\n  color: var( --new-green-color );\n  font-weight: var( --font-medium );\n  margin-left: var( --space-half );\n}\n\n.modal-page-create__check-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: var(--space-x2) var(--space-x2) var(--space-x3) var(--space-x2);\n  padding: var(--space);\n  border: 1px solid var(--new-gray-background-color);\n  border-radius: var(--space-half);\n}\n\n.modal-page-create__check-box.active {\n  border: 1px solid var(--new-green-color);\n}\n\n.modal-page-create__check-box__icon {\n  display: flex;\n  align-items: center;\n}\n\n.modal-page-create__check-box__icon span {\n  font-size: var(--space-x2);\n}\n\n.modal-page-create__check-box__icon .baloa-hyperlink-2 {\n  margin-left: var(--space-half-quarter);\n  font-weight: var(--font-regular);\n  color: var(--primary-dark-color);\n}\n\n.modal-page-create__check-box input[type=\"checkbox\" i] {\n  padding: 8px;\n}\n\n.select-field-more-options.page-team-create-modal__existing-page div#mui-component-select-selectedPage{\n  display: flex;\n  color: var( --primary-dark-color);\n}\n\n#menu-selectedPage .MuiPopover-paper{\n  height: 20rem;\n}\n\n.modal-page-create_newPage_select_item{\n  text-transform: none;\n}\n\n.modal-page-create_newPage_select_item .baloa-username{\n  color: var(--primary-dark-color);\n}\n\n.modal-finish_createTeam-buttons{\n  display: flex;\n  justify-content: flex-end;\n  margin-top: var(--space);\n}\n\n.page-information-form_left_submit{\n  margin-right: var(--space)\n}\n\n.modal-finish_createTeam_codeTeam{\n  display: flex;\n  align-items: baseline;\n  margin-bottom: var(--space);\n}\n\n.modal-finish_createTeam_code{\n  background: var(--new-background-color);\n  border-radius: 3px;\n  padding: var(--space-half);\n  width: 60%;\n  text-align: center;\n}\n\n.modal-finish_createTeam{\n  margin: var(--space-and-half);\n}\n\n.modal-finish_createTeam_code_click:hover{\n  cursor: pointer;\n}\n\n.modal-finish_createTeam .modal-finish_creaTeam_code_text.baloa-table{\n  font-size: 19px;\n}\n\n.modal-page-create-team-information_steps {\n  border: 1px solid var(--new-gray-background-color);\n  border-radius: 8px;\n  background-color: #EDF2FC;\n  margin: 25px 32px 26px 32px;\n  padding: 16px;\n}\n\n.modal-page-create-team-steps-icon p {\n  margin-left: 12px; \n}\n\n.modal-page-create-team-steps-icon{\n  display: flex;\n  padding-bottom: 16px;\n  align-items: center;\n}\n\n.modal-page-create-team-information_steps-info{\n  padding-bottom: 11px;\n}\n\n.modal-page-create-team-steps-positions{\n    color: var(--white-color);\n    background: #5489E7;\n    border-radius: 50%;\n    width: 26px;\n    height: 26px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n}\n\n.modal-page-create-team-information_icon{\n  background: var(--primary-dark-color);\n  color: var(--white-color);\n  width: 60px;\n  height: 60px;\n  left: 268px;\n  top: 0px;\n  border-radius: 50%;\n  padding: 15px;\n}\n\n.modal-page-create-team-information_icon span{\n  font-size: 30px;\n}\n\n.modal-page-create_newPage_select div#mui-component-select-selectedPage{\n color:var(--body-background-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n  .modal-page-create-team .modal2__container {\n    width: 100%;\n    margin: 0;\n    border-radius: 0;\n    height: 100%;\n    max-height: 100%;\n  }\n\n  .modal-page-create-team-container {\n    height: 100%;\n    padding: 0;\n  }\n\n  .modal-page-create-team-container .form,\n  .modal-page-create-team .modal2__content {\n    height: 100%;\n    overflow: scroll;\n  }\n\n  .modal-page-create_newPage_buttons {\n    display: block; \n    justify-content: unset; \n    margin-top: 0; \n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding: var(--space);\n  }\n\n  .modal-page-create-team-container .button {\n    width: 100%;\n  }\n\n  .modal-page-create-team.create-form .modal2__container {\n    width: 100%;\n  }\n\n  .modal-page-create-team.create-form .form,\n  .modal-page-create-team-container .form {\n    margin-top: var(--space-x3);\n  }\n\n  .modal-page-create_newPage_data_logo .tournament-photo {\n    width: 100px;\n    height: 100px;    \n  }\n\n  .modal-page-create-information-form {\n    flex-direction: column;\n  }\n\n  .modal-page-create_newPage_form_input .modal-page-create-information-form_input {\n    width: 100%;\n    margin-right: 0; \n    margin-left: 0; \n    padding: 0 var(--space);\n  }\n\n  .modal-page-create_newPage_form_input .modal-page-create-information-form_input_pagename {\n    margin: 0;\n    padding: 0 var(--space);\n  }\n\n  .modal-page-create_newPage_form_input .modal-page-create-information-form_input .input-field-label,\n  .modal-page-create_newPage_form_input .modal-page-create-information-form_input_pagename .input-field-label {\n    left: 12px;\n  }  \n\n  .modal-page-create_newPage_form_input {\n    height: 100%;\n  }\n\n  .modal-page-create-information-form_buttons {\n    margin-right: 0;\n    position: absolute;\n    bottom: 0;\n    display: unset;\n    width: 100%;\n    padding: var(--space);\n  }\n\n  .select-field.new-team-form__form__input .MuiInputBase-root {\n    width: 100%;\n  }\n\n  .form-group-new-team_form-buttons {\n    display: unset;\n    margin: 0;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding: 12px;\n  }\n\n  .page-team-create__team-code .modal2__container {\n    width: 80%;\n    border-radius: 0;\n    height: 45%;\n    border-radius: var(--space);\n  } \n\n  .modal-finish_createTeam p{\n    margin-bottom: 15px;\n  }\n\n  .modal-finish_createTeam_codeTeam{\n    margin-bottom: var(--space-x2);\n  }\n\n  .modal-finish_createTeam-buttons{\n    margin-top: 50px;\n  }\n\n  .modal-finish_creaTeam_code{\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    margin: 0 var(--space);\n  }\n\n  .modal-finish_createTeam .modal-finish_creaTeam_code_text.baloa-table{\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
